<template>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#43AA8B" dark>
      <v-toolbar-title >
        <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" @click.stop="$emit('drawerChanged')"></v-app-bar-nav-icon>
        <span>Co-diabético</span>
      </v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items>
        <v-btn text @click="didTapLogout">Logout</v-btn>
      </v-toolbar-items>
    </v-app-bar>
</template>

<script>
import { logout } from "@/firebase/api/auth"
export default {
  methods: {
    didTapLogout() {
      logout();
      this.$router.replace('/login');
    }
  }
}
</script>
